import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=27ecb59a&scoped=true&"
import script from "./Province.vue?vue&type=script&lang=js&"
export * from "./Province.vue?vue&type=script&lang=js&"
import style0 from "./Province.vue?vue&type=style&index=0&id=27ecb59a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ecb59a",
  null
  
)

export default component.exports